import { useNavigate } from 'react-router-dom'
import { Separator, Button } from '@/ui'

export const PracticeProfileFormCta = ({
  submitForm,
  isValid,
  isSubmitting,
}: {
  submitForm: () => void
  isValid: boolean
  isSubmitting: boolean
}) => {
  const navigate = useNavigate()

  return (
    <>
      <Separator className="my-2" />

      <div className="flex flex-col md:flex-row justify-between items-center w-full space-y-2 md:space-y-0 md:space-x-4">
        <Button
          onClick={() => navigate('/practice/profile')}
          variant="secondary"
          size="lg"
          className="w-full md:w-auto"
        >
          Cancel
        </Button>

        <Button
          onClick={submitForm}
          variant="primary"
          size="lg"
          className="w-full md:w-auto"
          disabled={!isValid || isSubmitting}
          loading={isSubmitting}
        >
          Save Changes
        </Button>
      </div>
    </>
  )
}
